import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import AuthLayout from "../components/layouts/authLayout";
import { routerPath } from "../config/constents";
import LoaderControl from "../components/layouts/helpers/loaderControl";
import AppLayout from "../components/layouts/appLayout";
import PlanLayout from "../components/layouts/planLayout";
import PreCaseLayout from "../components/layouts/preCaseLayout";
import BackOfficePrecaseLayout from "../components/layouts/backOfficePrecaseLayout";
import QcTrayPrecaseLayout from "../components/layouts/qcTrayPrecaseLayout";
import BackOfficePostcaseLayout from "../components/layouts/backOfficePostcaseLayout";
import QcTrayPostcaseLayout from "../components/layouts/qcTrayPoscaseLayout";
import PostCaseLayout from "../components/layouts/postCaseLayout";
import BackOfficeLayout from "../components/layouts/backOfficeLayout";
import AxiosProvider from "../providers/AxiosProvider";
import ChoosePlan from "../pages/plan/choosePlan";
import QcTrayPostcase from "../components/layouts/qcPostCase";
import QCTrayPreCase from "../components/layouts/qcPreCase";
import BOPostcase from "../components/layouts/backOfficePostCase";
import BOPreCase from "../components/layouts/backOfficePreCase";
import Payout from "../pages/payout/payout";
import Report from "../pages/reports/report";
import Verifier from "../pages/verifier/verifier";
import ServiceProvider from "../pages/serviceprovider/serviceProvider";



const Login = lazy(() => import("../pages/auth/login"));
const ForgotPassword = lazy(() => import("../pages/auth/forgotPassword"));

const Dashboard = lazy(() => import("../pages/dashboard"));
// const NewRequest = lazy(() => import("../pages/dashboard/component/newrequest"));
const ServiceCatalog = lazy(() => import("../pages/servicecatalog/servicecatalog"));
const ServiceCatalogVerification = lazy(() => import("../pages/servicecatalog/catalogverification"));
// const UsageReport = lazy(() => import("../pages/createown/usagereport"));
// const InputData = lazy(() => import("../pages/createown/inputdata"));
//const Verification = lazy(() => import("../pages/createown/verification"));

//const PreCase                  = lazy(() => import('../components/layouts/preCaseLayout'));
const PreCaseDetails = lazy(() => import("../pages/inputData/preCase/index"));
const PreCaseCustomerdetails = lazy(() => import("../pages/inputData/preCase/Customerdetails"));
const PreCaseOfficedetails = lazy(() => import("../pages/inputData/preCase/Officedetails"));
const PreCaseOtherdetails = lazy(() => import("../pages/inputData/preCase/Otherdetails"));
const PostCase = lazy(() => import("../pages/inputData/postCase"));
const PostCaseCustomerdetails = lazy(() => import("../pages/inputData/postCase/Customerdetails"));
const PostCaseOtherdetails = lazy(() => import("../pages/inputData/postCase/Otherdetails"));
//precase Backoffice
const ByServiceProviderBOT = lazy(() => import("./../pages/inputData/backofficetray/byserviceproviderbot"));
const BackofficeTray = lazy(() => import("../pages/inputData/backofficetray/precase"));
const BackofficeCustomerRequest = lazy(() => import("../pages/inputData/backofficetray/customerRequest"));
const QctrayCustomerRequest = lazy(() => import("../pages/inputData/qctray/customerRequest"));
const PostbackofficeTray = lazy(() => import("../pages/inputData/backofficetray/precase/inspectionDetails"));
const Postcasedocument = lazy(() => import("../pages/inputData/backofficetray/precase/postCaseDocuments"));
const PostImages = lazy(() => import("../pages/inputData/backofficetray/precase/Posttimages"));
//postcase BackOfficeTray
const Applicatons = lazy(() => import("../pages/sampler/application"))
const BackOfficePreEmployment = lazy(() => import("../pages/inputData/backofficetray/newPreEmployment"));

const PostcaseBackofficeTray = lazy(() => import("../pages/inputData/backofficetray/postcase"));
const PostcasePostbackofficeTray = lazy(() => import("../pages/inputData/backofficetray/postcase/inspectionDetails"));
const PostcasePostcasedocument = lazy(() => import("../pages/inputData/backofficetray/postcase/postCaseDocuments"));
const PostcasePostImages = lazy(() => import("../pages/inputData/backofficetray/postcase/Posttimages"));

const KycDetails = lazy(() => import("../pages/inputData/backofficetray/kycDetails"));
const SandboxKYC = lazy(() => import("../pages/inputData/backofficetray/SandboxKYC"));
//QC tray
const Qctray = lazy(() => import("../pages/inputData/qctray/precase"));

const QctrayInspectionDetails = lazy(() => import("../pages/inputData/qctray/precase/inspectionDetails"));
const QctraycaseDocuments = lazy(() => import("../pages/inputData/qctray/precase/postCaseDocuments"));
const QctrayInspectionImages = lazy(() => import("../pages/inputData/qctray/precase/Posttimages"));
const QCServiceProvider = lazy(() => import("../pages/QC/index"))

const QCPreLayout = lazy(() => import("../components/layouts/qcPostCase"))

// const Qctray = lazy(() => import("../pages/inputData/qctray"));
// const Postdocumentqctray = lazy(
//   () => import("../pages/inputData/qctray/Postdocumentqctray")
// );
// const PostbackofficeqcTray = lazy(
//   () => import("../pages/inputData/qctray/Postbackofficeqctray")
// );
// const PostImageqctray = lazy(
//   () => import("../pages/inputData/qctray/Postimageqctray")
// );

const PostcaseMisreport = lazy(() => import("../pages/inputData/misreport/postcase"));
const PrecaseMisreport = lazy(() => import("../pages/inputData/misreport/precase"));
const CustomMISReport = lazy(() => import("../pages/inputData/misreport/report/CustomMisReport"));
const CustomerRequestMISReport = lazy(() => import("../pages/inputData/misreport/customerRequest"));
const Invoice = lazy(() => import("../pages/accounts/invoice"));
const Payroll = lazy(() => import("../pages/accounts/payroll"));
const CommissionPayout = lazy(() => import("../pages/accounts/commissionPayout"));
const StaffDetails = lazy(() => import("../pages/staff/staffDetails"));
// const Mappings = lazy(() => import("../pages/staff/mappings"));
//const Onboard = lazy(() => import("../pages/configurations/onboard"));
const Vendor = lazy(() => import("../pages/configurations/vendor"));
const Branch = lazy(() => import("../pages/configurations/branch"));
const Banks = lazy(() => import("../pages/configurations/banks"));
const ThankYou = lazy(() => import("../pages/thankyou"));
const Authority = lazy(() => import("../pages/configurations/authority"));

//const Agency = lazy(() => import("../pages/configurations/agency"));
const Templates = lazy(() => import("../pages/configurations/templates"));
const ProductMaster = lazy(() => import("../pages/configurations/productmaster"));
const ProductDetails = lazy(() => import("../pages/configurations/productdetails"));
const TatMatrix = lazy(() => import("../pages/configurations/tatmatrix"));
const QueryMaster = lazy(() => import("../pages/configurations/querymaster"));
const CommissionToEmployee = lazy(() => import("../pages/configurations/commissionToemployee"));
const QueryType = lazy(() => import("../pages/configurations/querytype"));
const HubMaster = lazy(() => import("../pages/configurations/hubmaster"));
const UserMaster = lazy(() => import("../pages/configurations/usermaster"));
const AccessManagement = lazy(() => import("../pages/configurations/accessmanagement"));
const Routeassignment = lazy(() => import("../pages/configurations/routeassignment"));
const SegementMaster = lazy(() => import("../pages/configurations/segmentmaster"));
const VerificationMaster = lazy(() => import("../pages/configurations/verificationmaster"));
const HolidayMaster = lazy(() => import("../pages/configurations/holidaymaster"));
const RouteMaster = lazy(() => import("../pages/configurations/RouteMaster"));
const NewPassWord = lazy(() => import("../pages/auth/password"));
const CoApplicant = lazy(() => import("../pages/inputData/preCase/coapplicant"));
const Guarantor = lazy(() => import("../pages/inputData/preCase/guarantor"));
const CaseReassignment = lazy(() => import("../pages/configurations/CaseReassign"));
const NotFound = lazy(() => import("../pages/notFound"));
const NewRequest = lazy(() => import("../pages/dashboard/component/newrequest"));
const Verification = lazy(() => import("../pages/createown/verification"));
const InputData = lazy(() => import("../pages/createown/inputdata"));
const UsageReport = lazy(() => import("../pages/createown/usagereport"));
const Document = lazy(() => import("../pages/createown/document"));
const UserRole = lazy(() => import("../pages/configurations/role"));
const SMTPMaster = lazy(() => import("../pages/configurations/smtpMaster"));

const BackOfficeAddressVerification = lazy(() => import("../pages/inputData/backofficetray/addressverification"));
const QCAddressVerification = lazy(() => import("../pages/QC/addressverification"));
const QCNewPreEmployment = lazy(() => import("../pages/QC/newpreemployment"));

//BY Service Provider
const ByServiceProvider = lazy(() => import("../pages/createown/byserviceProvider"));
const ByServiceProviderNew = lazy(() => import("../pages/createown/byServiceProviderNew/home"));
const NewPreEmployment = lazy(() => import("../pages/createown/byServiceProviderNew/newPreEmployment"));

const PreEmployment = lazy(() => import("../pages/createown/preemployment"));
const PostEmployment = lazy(() => import("../pages/createown/postemployment"));
const Education = lazy(() => import("../pages/createown/education"));
const ServiceDocument = lazy(() => import("../pages/createown/servicedocument"));
const Police = lazy(() => import("../pages/createown/police"));
const AddressVerification = lazy(() => import("../pages/createown/addressverification"));
const PreEmploymentBO = lazy(() => import("../pages/inputData/backofficetray/preemployement"));
const PostEmploymentBO = lazy(() => import("../pages/inputData/backofficetray/postemployment"));
const BulkUpload = lazy(() => import("../pages/createown/bulkupload"));


//From Verifyon
const FromVerifyon = lazy(() => import("../pages/createown/fromverifyon/home"));
const VerifyonPreEmployment = lazy(() => import("../pages/createown/fromverifyon/preemployment"));
const VerifyonPostEmployment = lazy(() => import("../pages/createown/fromverifyon/postemployment"));
const VerifyonEducation = lazy(() => import("../pages/createown/fromverifyon/education"));
const VerifyonDocument = lazy(() => import("../pages/createown/fromverifyon/document"));
const VerifyonPolice = lazy(() => import("../pages/createown/fromverifyon/police"));

//Finance
const FinanceInvoice = lazy(() => import("../pages/finance/invoice"));
const FinancePaymetForVerifyon = lazy(() => import("../pages/finance/paymenyforverifyon"));
const FinancePayroll = lazy(() => import("../pages/finance/payroll"));
const FinanceCommissionPayout = lazy(() => import("../pages/finance/commissionpayout"));


function AppRoutes() {
  return (
    <>
      <AxiosProvider />
      <Routes>
        <Route path={routerPath.auth.home} element={<AuthLayout />}>
          <Route
            path={routerPath.auth.home}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Login />
              </Suspense>
            }
          />
          <Route
            path={routerPath.auth.updatenewpassword}
            element={
              <Suspense fallback={<LoaderControl />}>
                <NewPassWord />
              </Suspense>
            }
          />
        </Route>

        <Route
          path={routerPath.auth.memberForgotPassword}
          element={
            <Suspense fallback={<LoaderControl />}>
              <ForgotPassword />
            </Suspense>
          }
        />

        <Route
          path={routerPath.serviceProvider}
          element={
            <Suspense fallback={<LoaderControl />}>
              <Login />
            </Suspense>
          }
        />
        <Route path={routerPath.auth.serviceProvider} element={<AuthLayout />}></Route>

        <Route path={routerPath.serviceProvider} element={<AppLayout />}></Route>


        <Route path={routerPath.plan.choosePlan} element={<PlanLayout />}>

          <Route
            path={routerPath.plan.choosePlan}
            element={
              <Suspense fallback={<LoaderControl />}>
                <ChoosePlan />
              </Suspense>
            }
          />

        </Route>
        <Route path={routerPath.home} element={<AppLayout />}>
          <Route
            path={routerPath.dashboard}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Dashboard />
              </Suspense>
            }
          />
          <Route
            path={routerPath.newRequest}
            element={
              <Suspense fallback={<LoaderControl />}>
                <NewRequest />
              </Suspense>
            }
          />
          {/* <Route path={routerPath.case.dashboard} element={<Suspense fallback={<LoaderControl/>}><Dashboard/></Suspense>}/> */}

          <Route
            path={routerPath.createown.Verification}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Verification />
              </Suspense>
            } />
          <Route
            path={routerPath.createown.inputdata.byServiceProvider}
            element={
              <Suspense fallback={<LoaderControl />}>
                <ByServiceProvider />
              </Suspense>
            } />

          <Route
            path={routerPath.createown.inputdata.byServiceProviderNew.home}
            element={
              <Suspense fallback={<LoaderControl />}>
                <ByServiceProviderNew />
              </Suspense>
            } />

          <Route
            path={routerPath.createown.inputdata.byServiceProviderNew.premeployment}
            element={
              <Suspense fallback={<LoaderControl />}>
                <NewPreEmployment />
              </Suspense>
            } />

          <Route
            path={routerPath.createown.inputdata.bulkupload}
            element={
              <Suspense fallback={<LoaderControl />}>
                <BulkUpload />
              </Suspense>
            } />


          <Route
            path={routerPath.createown.premeployment}
            element={
              <Suspense fallback={<LoaderControl />}>
                <PreEmployment />
              </Suspense>
            } />
          <Route
            path={routerPath.createown.postemployment}
            element={
              <Suspense fallback={<LoaderControl />}>
                <PostEmployment />
              </Suspense>
            } />

          <Route
            path={routerPath.createown.education}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Education />
              </Suspense>
            } />
          <Route
            path={routerPath.createown.servicedocument}
            element={
              <Suspense fallback={<LoaderControl />}>
                <ServiceDocument />
              </Suspense>
            } />
          <Route
            path={routerPath.createown.police}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Police />
              </Suspense>
            } />
          <Route
            path={routerPath.createown.inputdata.fromVerifyon.home}
            element={
              <Suspense fallback={<LoaderControl />}>
                <FromVerifyon />
              </Suspense>
            } />

          <Route
            path={routerPath.createown.inputdata.fromVerifyon.premeployment}
            element={
              <Suspense fallback={<LoaderControl />}>
                <VerifyonPreEmployment />
              </Suspense>
            } />

          <Route
            path={routerPath.createown.inputdata.fromVerifyon.postemployment}
            element={
              <Suspense fallback={<LoaderControl />}>
                <VerifyonPostEmployment />
              </Suspense>
            } />

          <Route
            path={routerPath.createown.inputdata.fromVerifyon.education}
            element={
              <Suspense fallback={<LoaderControl />}>
                <VerifyonEducation />
              </Suspense>
            } />

          <Route
            path={routerPath.createown.inputdata.fromVerifyon.police}
            element={
              <Suspense fallback={<LoaderControl />}>
                <VerifyonPolice />
              </Suspense>
            } />

          <Route
            path={routerPath.createown.inputdata.fromVerifyon.verifyondocument}
            element={
              <Suspense fallback={<LoaderControl />}>
                <VerifyonDocument />
              </Suspense>
            } />
          <Route
            path={routerPath.createown.usagereport}
            element={
              <Suspense fallback={<LoaderControl />}>
                <UsageReport />
              </Suspense>
            } />
          <Route
            path={routerPath.createown.document}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Document />
              </Suspense>
            } />
          <Route
            path={routerPath.servicecatalog.Servicecatalog}
            element={
              <Suspense fallback={<LoaderControl />}>
                <ServiceCatalog />
              </Suspense>
            } />
          <Route
            path={routerPath.reports.reports}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Report />
              </Suspense>
            }
          />
          <Route
            path={routerPath.finance.invoice}
            element={
              <Suspense fallback={<LoaderControl />}>
                <FinanceInvoice />
              </Suspense>
            } />

          <Route
            path={routerPath.finance.paymentforveriyon}
            element={
              <Suspense fallback={<LoaderControl />}>
                <FinancePaymetForVerifyon />
              </Suspense>
            } />

          <Route
            path={routerPath.finance.payroll}
            element={
              <Suspense fallback={<LoaderControl />}>
                <FinancePayroll />
              </Suspense>
            } />

          <Route
            path={routerPath.finance.commissionpayout}
            element={
              <Suspense fallback={<LoaderControl />}>
                <FinanceCommissionPayout />
              </Suspense>
            } />

          <Route path={routerPath.case.home} element={<PreCaseLayout />}>
            <Route
              path={routerPath.case.preCase}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <PreCaseDetails />
                </Suspense>
              }
            />
            <Route
              path={routerPath.case.preCaseCustomerdetails}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <PreCaseCustomerdetails />
                </Suspense>
              }
            />
            <Route
              path={routerPath.case.preCaseCoApplicant}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <CoApplicant />
                </Suspense>
              }
            />
            <Route
              path={routerPath.case.preCaseGuarantor}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <Guarantor />
                </Suspense>
              }
            />
            <Route
              path={routerPath.case.preCaseOfficedetails}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <PreCaseOfficedetails />
                </Suspense>
              }
            />
            <Route
              path={routerPath.case.preCaseOtherdetails}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <PreCaseOtherdetails />
                </Suspense>
              }
            />
          </Route>
          <Route path={routerPath.case.home} element={<PostCaseLayout />}>
            <Route
              path={routerPath.case.postCase}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <PostCase />
                </Suspense>
              }
            />
            <Route
              path={routerPath.case.postCaseCustomerdetails}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <PostCaseCustomerdetails />
                </Suspense>
              }
            />
            <Route
              path={routerPath.case.postCaseOtherdetails}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <PostCaseOtherdetails />
                </Suspense>
              }
            />
          </Route>
          <Route
            path={routerPath.backoffice.byServiceProviderBOT}
            element={
              <Suspense fallback={<LoaderControl />}>
                <ByServiceProviderBOT />
              </Suspense>
            } />
          <Route
            path={routerPath.backoffice.addressVerification}
            element={
              <Suspense fallback={<LoaderControl />}>
                <BackOfficeAddressVerification />
              </Suspense>
            } />
          <Route
            path={routerPath.backoffice.premeployment}
            element={
              <Suspense fallback={<LoaderControl />}>
                <PreEmploymentBO />
              </Suspense>
            } />

          <Route
            path={routerPath.backoffice.newpreemployment}
            element={
              <Suspense fallback={<LoaderControl />}>
                <BackOfficePreEmployment />
              </Suspense>
            } />
          <Route
            path={routerPath.backoffice.postemployment}
            element={
              <Suspense fallback={<LoaderControl />}>
                <PostEmploymentBO />
              </Suspense>
            } />

          <Route
            path={routerPath.qcTray.addressVerification}
            element={
              <Suspense fallback={<LoaderControl />}>
                <QCAddressVerification />
              </Suspense>
            } />

          <Route
            path={routerPath.qcTray.newpreemployment}
            element={
              <Suspense fallback={<LoaderControl />}>
                <QCNewPreEmployment />
              </Suspense>
            } />

          <Route
            path={routerPath.case.addressVerification}
            element={
              <Suspense fallback={<LoaderControl />}>
                <AddressVerification />
              </Suspense>
            } />

          <Route path={routerPath.case.home} element={<BackOfficeLayout />}>
            <Route
              path={routerPath.case.backofficetray}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <BackofficeTray />
                </Suspense>
              }
            />
            <Route
              path={routerPath.case.postbackofficetray}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <PostbackofficeTray />
                </Suspense>
              }
            />

            <Route
              path={routerPath.case.postcasedocument}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <Postcasedocument />
                </Suspense>
              }
            />
            <Route
              path={routerPath.case.postimages}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <PostImages />
                </Suspense>
              }
            />
          </Route>

          {/* <Route path={routerPath.case.home} element={<BackOfficePostcaseLayout />}>
            <Route
              path={routerPath.case.backofficetray}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <BackOfficePostcaseLayout />
                </Suspense>
              }
            />
            <Route
              path={routerPath.case.postbackofficetray}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <BackOfficePostcaseLayout />
                </Suspense>
              }
            />
            <Route
              path={routerPath.case.postcasedocument}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <PostcasePostcasedocument />
                </Suspense>
              }
            />
            <Route
              path={routerPath.case.postimages}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <PostcasePostImages />
                </Suspense>
              }
            />
          </Route> */}
          <Route
            path={routerPath.case.qctray}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Qctray />
              </Suspense>
            }
          />

          <Route
            path={routerPath.qcTray.qcserviceProvider}
            element={
              <Suspense fallback={<LoaderControl />}>
                <QCServiceProvider />
              </Suspense>
            }
          />
          {/* element={<BackOfficePrecaseLayout />} */}
          <Route path={routerPath.backoffice.home} >
            <Route
              path={routerPath.backoffice.precase}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <BOPreCase />
                </Suspense>
              }
            />
            <Route
              path={routerPath.backoffice.postcase}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <BOPostcase />
                </Suspense>
              }
            />
            <Route
              path={routerPath.backoffice.customerrequest}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <BackofficeCustomerRequest />
                </Suspense>
              }
            />
            <Route
              path={routerPath.backoffice.kycDetails}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <KycDetails />
                </Suspense>
              }
            />
            <Route
              path={routerPath.backoffice.kycSandboxDetails}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <SandboxKYC />
                </Suspense>
              }
            />
          </Route>

          <Route path={routerPath.qcTray.home} element={<QCTrayPreCase />}>
            <Route
              path={routerPath.qcTray.precase}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <QCTrayPreCase />
                </Suspense>
              }
            />
          </Route>

          <Route path={routerPath.qcTray.home} element={<QctrayCustomerRequest />}>
            <Route
              path={routerPath.qcTray.customerrequest}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <QctrayCustomerRequest />
                </Suspense>
              }
            />
          </Route>


          <Route path={routerPath.qcTray.home} element={<QcTrayPostcase />}>
            <Route
              path={routerPath.qcTray.postcase}
              element={
                <Suspense fallback={<LoaderControl />}>
                  <QcTrayPostcase />
                </Suspense>
              }
            />
          </Route>
          <Route
            path={routerPath.case.postdocumentqctray}
            element={
              <Suspense fallback={<LoaderControl />}>
                <QctraycaseDocuments />
              </Suspense>
            }
          />
          <Route
            path={routerPath.case.postbackofficeqctray}
            element={
              <Suspense fallback={<LoaderControl />}>
                <QctrayInspectionDetails />
              </Suspense>
            }
          />
          <Route
            path={routerPath.case.postimageqctray}
            element={
              <Suspense fallback={<LoaderControl />}>
                <QctrayInspectionImages />
              </Suspense>
            }
          />

          <Route
            path={routerPath.misreport.postcase}
            element={
              <Suspense fallback={<LoaderControl />}>
                < PostcaseMisreport />
              </Suspense>
            }
          />
          <Route
            path={routerPath.misreport.precase}
            element={
              <Suspense fallback={<LoaderControl />}>
                <PrecaseMisreport />
              </Suspense>
            }
          />
          <Route
            path={routerPath.accounts.invoice}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Invoice />
              </Suspense>
            }
          />

          <Route
            path={routerPath.accounts.payroll}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Payroll />
              </Suspense>
            }
          />
          <Route
            path={routerPath.accounts.commissionPayout}
            element={
              <Suspense fallback={<LoaderControl />}>
                <CommissionPayout />
              </Suspense>
            }
          />
          {/* <Route
            path={routerPath.newRequest}
            element={
              <Suspense fallback={<LoaderControl />}>
                <NewRequest />
              </Suspense>
            }
          /> */}
          <Route
            path={routerPath.staff.staffDetails}
            element={
              <Suspense fallback={<LoaderControl />}>
                <StaffDetails />
              </Suspense>
            }
          />
          {/* <Route
            path={routerPath.staff.mapping}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Mappings />
              </Suspense>
            }
          /> */}
          {/* <Route
            path={routerPath.config.onboard}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Onboard />
              </Suspense>
            }
          /> */}
          <Route
            path={routerPath.config.vendor}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Vendor />
              </Suspense>
            }
          />
          <Route
            path={routerPath.config.branch}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Branch />
              </Suspense>
            }
          />
          <Route
            path={routerPath.config.banks}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Banks />
              </Suspense>
            }
          />
          <Route
            path={routerPath.config.authority}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Authority />
              </Suspense>
            }
          />

          {/* <Route
            path={routerPath.config.agency}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Agency />
              </Suspense>
            }
          /> */}
          <Route
            path={routerPath.config.productmaster}
            element={
              <Suspense fallback={<LoaderControl />}>
                <ProductMaster />
              </Suspense>
            }
          />
          <Route
            path={routerPath.config.productdetails}
            element={
              <Suspense fallback={<LoaderControl />}>
                <ProductDetails />
              </Suspense>
            }
          />
          <Route
            path={routerPath.config.tatmatrix}
            element={
              <Suspense fallback={<LoaderControl />}>
                <TatMatrix />
              </Suspense>
            }
          />
          <Route
            path={routerPath.config.querymaster}
            element={
              <Suspense fallback={<LoaderControl />}>
                <QueryMaster />
              </Suspense>
            }
          />
          {/* <Route
            path={routerPath.config.querytype}
            element={
              <Suspense fallback={<LoaderControl />}>
                <QueryType />
              </Suspense>
            }
          /> */}
          <Route
            path={routerPath.config.hubmaster}
            element={
              <Suspense fallback={<LoaderControl />}>
                <HubMaster />
              </Suspense>
            }
          />
          <Route
            path={routerPath.config.usermaster}
            element={
              <Suspense fallback={<LoaderControl />}>
                <UserMaster />
              </Suspense>
            }
          />

          <Route
            path={routerPath.config.userRole}
            element={
              <Suspense fallback={<LoaderControl />}>
                <UserRole />
              </Suspense>
            }
          />
          <Route
            path={routerPath.config.smtpmaster}
            element={
              <Suspense fallback={<LoaderControl />}>
                <SMTPMaster />
              </Suspense>
            }
          />

          <Route
            path={routerPath.config.accessmanagement}
            element={
              <Suspense fallback={<LoaderControl />}>
                <AccessManagement />
              </Suspense>
            }
          />
          {/* <Route
            path={routerPath.config.routeassignment}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Routeassignment />
              </Suspense>
            }
          /> */}
          <Route
            path={routerPath.config.segmentmaster}
            element={
              <Suspense fallback={<LoaderControl />}>
                <SegementMaster />
              </Suspense>
            }
          />
          <Route
            path={routerPath.config.verificationmaster}
            element={
              <Suspense fallback={<LoaderControl />}>
                <VerificationMaster />
              </Suspense>
            }
          />
          <Route
            path={routerPath.config.holidayMaster}
            element={
              <Suspense fallback={<LoaderControl />}>
                <HolidayMaster />
              </Suspense>
            }
          />
          <Route
            path={routerPath.config.commissionToemployee}
            element={
              <Suspense fallback={<LoaderControl />}>
                <CommissionToEmployee />
              </Suspense>
            }
          />
          <Route
            path={routerPath.config.routeMaster}
            element={
              <Suspense fallback={<LoaderControl />}>
                <RouteMaster />
              </Suspense>
            }
          />
          <Route
            path={routerPath.sampler.application}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Applicatons />
              </Suspense>
            } />

          <Route
            path={routerPath.catalogverification}
            element={
              <Suspense fallback={<LoaderControl />}>
                <ServiceCatalogVerification />
              </Suspense>
            } />

          {/* <Route 
          path = {routerPath.createown.usagereport}
          element={
            <Suspense fallback={<LoaderControl/>}>
               <UsageReport/>
            </Suspense>
          }/>
           <Route 
          path = {routerPath.createown.inputdata}
          element={
            <Suspense fallback={<LoaderControl/>}>
               <InputData/>
            </Suspense>
          }/> */}




          <Route
            path={routerPath.config.template}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Templates />
              </Suspense>
            }
          />
          <Route
            path={routerPath.config.caseReassign}
            element={
              <Suspense fallback={< LoaderControl />}>
                < CaseReassignment />
              </Suspense>
            }
          />
          <Route
            path={routerPath.payout}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Payout />
              </Suspense>
            }
          />
          <Route
            path={routerPath.verifier.verifier}
            element={
              <Suspense fallback={<LoaderControl />}>
                <Verifier />
              </Suspense>
            }
          />
          <Route
            path={routerPath.serviceprovider.serviceProvider}
            element={
              <Suspense fallback={<LoaderControl />}>
                <ServiceProvider />
              </Suspense>
            }
          />
          <Route
            path={routerPath.misreport.MisCustomReport}
            element={
              <Suspense fallback={< LoaderControl />}>
                < CustomMISReport />
              </Suspense>
            }
          />
          <Route
            path={routerPath.misreport.CustomerRequest}
            element={
              <Suspense fallback={< LoaderControl />}>
                < CustomerRequestMISReport />
              </Suspense>
            }
          />
          <Route
            path={routerPath.thankyou}
            element={
              <Suspense fallback={<LoaderControl />}>
                <ThankYou />
              </Suspense>
            }
          />
        </Route>
        <Route path={"*"} element={<NotFound />} />
      </Routes >
    </>
  );
}

export default AppRoutes;
